import type {
  CourtRank,
  MinorSuit,
} from "./types";

export const MINOR_SUITS: MinorSuit[] = [
  "wands",
  "cups",
  "swords",
  "pentacles",
];

export const COURT_ORDER: CourtRank[] = [
  "pip",
  "page",
  "knight",
  "queen",
  "king",
];

export const COURT_NUMBER: Record<
  Exclude<CourtRank, "major" | "simple" | "pip">,
  number
> = {
  page: 11,
  knight: 12,
  queen: 13,
  king: 14,
};

export const NUMBER_COURT: Record<
  11 | 12 | 13 | 14,
  Exclude<CourtRank, "major" | "simple" | "pip">
> = {
  11: "page",
  12: "knight",
  13: "queen",
  14: "king",
};

